
import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD, { modules } from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsView from "../../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import ModelDialogLayer from "../../../../gameCommon/basic/ModelDialogLayer";
import getOneBundle, { BUNDLE_SMALL_NAME} from "../../../BundleResourceConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import SearchLight from "./SearchLight";

const { ccclass, property } = cc._decorator;

@ccclass
export default class KaoGuSpecialPage extends BasePopUpLayer {
    @property({ type: cc.Node, displayName: "火把" })
    node_fire: cc.Node = null;
    @property({ type: cc.Node, displayName: "物品列表" })
    itemGroup: cc.Node = null;
    @property({ type: SearchLight, displayName: "黑幕" })
    node_mask: SearchLight = null;

    @property(cc.Node)
    nodeSpecialGoods: cc.Node = null;

    insideNum: number = 0;

    insideNodeList: cc.Node[] = [];
    outsideNodeList: cc.Node[] = [];

    over: boolean = false;

    lightWordPos: cc.Vec2 = null;

    private oriSpecialHeight = 0;

    onLoad() {
        this.node_fire.on(cc.Node.EventType.TOUCH_START, this.touchBegin, this);
        this.node_fire.on(cc.Node.EventType.TOUCH_MOVE, this.touchMove, this);
        this.node_mask.node.active = true;
        // const t=cc.tween(this.node_mask).to(0.3)
        this.oriSpecialHeight = this.nodeSpecialGoods.height;
        this.nodeSpecialGoods.height = 0;

        this.init();
    }
   
    async init() {

        this.scheduleOnce(() => {
            this.setFirePos();
        })
    }

    async loadBottonImg(sprite: cc.Sprite, url: string, isMine: boolean) {
        let st = isMine ? 'res/kaogu/kaoguitem/' : 'res/kaogu/kaoguMineItem/';
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.kaogu, false);
        await new Promise<void>(resolve=>{
            bundle.load(st + url, cc.Texture2D, (e, ass: cc.Texture2D) => {
                if (e) {
                    console.warn(e, '矿内显示图片出错')
                    sprite.spriteFrame = null
                    resolve();
                    return
                }
                sprite.spriteFrame = new cc.SpriteFrame(ass);
                resolve();
            });
        });
    }
    
    async setGameOver() {
        if (this.over) return;
        if (this.itemGroup.childrenCount <= 0) {
            this.over = true;
            // 全部获取完了 直接进刮
            ModelDialogLayer.show('当前矿山已完全探索完, 是否退出'
            , ()=> {
                this.onClickBack();
            }, ()=> {
                
            }
            , '留 下'
            , '退 出'
            , false
            , UI_Z_INDEX.DIALOG-1
            );
        }
    }

    async onClickGoods(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let goods = Number(data);
        let node = event.getCurrentTarget();
        this.getGoods(node, goods);
    }

    async getGoods(node: cc.Node, goods: number) {
        node.destroy();

        let addGoodsList = {};
        addGoodsList[goods] = 1;
        await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
        this.setGameOver();
        NormalGameManager._instance.onPushGoods(goods, 1);
    }

    onClickSpecialGoods(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let goods = Number(data);
        let node = event.getCurrentTarget();
        let btnItem = node.getComponent(cc.Button);
        btnItem.interactable = false;
        // node.destroy();

        this.nodeSpecialGoods.height = 0;

        cc.tween(this.nodeSpecialGoods)
        .to(1, {height: this.oriSpecialHeight})
        .call(() => {
            this.getGoods(node, goods);
        })
        .start();
    }
    
    setFirePos() {
        this.lightWordPos = this.node_fire.parent.convertToWorldSpaceAR(cc.v2(this.node_fire.x - 50, this.node_fire.y + 210))
        this.node_mask.setPos(this.lightWordPos);
    }

    public touchBegin(event: cc.Event.EventTouch) {
        this.node_fire.parent.x += event.getDeltaX();
        this.node_fire.parent.y += event.getDeltaY();
        this.node_fire.parent.y = data_control.getValueOfAreaMinMax(this.node_fire.parent.y, -cc.winSize.height / 2 + 30, cc.winSize.height / 2 - 200)
        // this.node_fire.setPosition(this.node_fire.parent.convertToNodeSpaceAR(event.getLocation()))
        this.setFirePos();
    }

    public touchMove(event: cc.Event.EventTouch) {
        this.node_fire.parent.x += event.getDeltaX();
        this.node_fire.parent.y += event.getDeltaY();
        this.node_fire.parent.y = data_control.getValueOfAreaMinMax(this.node_fire.parent.y, -cc.winSize.height / 2 + 30, cc.winSize.height / 2 - 200)
        this.setFirePos();
    }

    async onClickBack() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        // 判断有没有全部弄完
        if (this.itemGroup.childrenCount > 0) {
            ModelDialogLayer.show('当前矿山还没有完全探索完，\n退出后将无法继续本次探索，\n是否退出？'
            , ()=> {

            }, ()=> {
                this.node && this.node.isValid && this.node.destroy();
            }
            , '退 出'
            , '留 下'
            );
        } else this.node && this.node.isValid && this.node.destroy();
    }
   
}